import { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/stores/cartStore";
import AboKonfiguratorDrawer from "./AboKonfiguratorDrawer";

const fmt = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export default function KorbPage() {
  const items = useCart((s) => s.items);
  const setQty = useCart((s) => s.setQty);
  const removeItem = useCart((s) => s.removeItem);
  const clear = useCart((s) => s.clear);
  const total = useCart((s) => s.totalCents());
  const [aboOpen, setAboOpen] = useState(false);

  if (items.length === 0) {
    return (
      <div className="card text-center space-y-3">
        <div className="text-5xl">🧺</div>
        <h1 className="text-2xl font-bold text-hof-900">Ihr Korb ist leer</h1>
        <p className="text-hof-600">Stöbern Sie im Hofladen und füllen Sie ihn mit frischen Produkten.</p>
        <Link to="/shop" className="btn-primary inline-block">Zum Hofladen</Link>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-brand font-bold text-wappen-700">Ihr Korb</h1>

      <div className="card p-0 divide-y divide-hof-100">
        {items.map((i) => (
          <div key={i.product_id} className="p-4 flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <div className="font-medium text-hof-900">{i.name}</div>
              <div className="text-sm text-hof-500">{fmt.format(i.unit_price_cents / 100)} je {i.unit}</div>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setQty(i.product_id, i.qty - 1)} className="btn-secondary w-10 p-0" aria-label="Menge verringern">−</button>
              <input
                value={i.qty}
                onChange={(e) => setQty(i.product_id, parseInt(e.target.value) || 0)}
                className="w-14 text-center input py-2 px-2"
                inputMode="numeric"
              />
              <button onClick={() => setQty(i.product_id, i.qty + 1)} className="btn-secondary w-10 p-0" aria-label="Menge erhöhen">+</button>
            </div>
            <div className="w-24 text-right font-medium">{fmt.format((i.qty * i.unit_price_cents) / 100)}</div>
            <button onClick={() => removeItem(i.product_id)} className="btn-ghost p-2" aria-label="Entfernen">✕</button>
          </div>
        ))}
      </div>

      <div className="card flex items-center justify-between">
        <button onClick={clear} className="btn-ghost">Korb leeren</button>
        <div className="text-right">
          <div className="text-sm text-hof-500">Zwischensumme</div>
          <div className="text-2xl font-bold text-wiese-700">{fmt.format(total / 100)}</div>
        </div>
      </div>

      <div className="space-y-2">
        <Link to="/shop/checkout" className="btn-primary w-full justify-center text-lg py-4">
          Zur Kasse →
        </Link>
        <button onClick={() => setAboOpen(true)} className="btn-secondary w-full justify-center">
          📅 Als regelmäßiges Abo bestellen
        </button>
      </div>

      {aboOpen && <AboKonfiguratorDrawer onClose={() => setAboOpen(false)} />}
    </div>
  );
}
